import React from "react";
import { Link } from "react-router-dom";
import type { SiteBlogPost } from "../../config/blogs";
import icon01 from "../../images/icon/blog-icon01.svg";
import icon02 from "../../images/icon/blog-icon02.svg";

interface BlogPostCardProps {
  post: SiteBlogPost;
  small?: boolean;
  delay?: string;
}

const BlogPostCard: React.FC<BlogPostCardProps> = ({ post, small = false, delay = "0ms" }) => {
  return (
    <div
      className={`xb-blog-item ${small ? "xb-small-blog-item" : ""} wow fadeInUp`}
      data-wow-delay={delay}
      data-wow-duration="600ms"
    >
      <div className="xb-item--inner img-hove-effect xb-border">
        <div className="xb-img">
          <Link to="/blog-details">
            <img src={post.image} alt={post.title} />
          </Link>
        </div>
        <div className="xb-item--holder">
          <ul className="xb-item--meta list-unstyled ul_li">
            <li>
              <img src={icon01} alt="" aria-hidden="true" /> {post.category}
            </li>
            <li>
              <img src={icon02} alt="" aria-hidden="true" /> {post.date}
            </li>
          </ul>
          <h2 className="xb-item--title">
            <Link to="/blog-details">{post.title}</Link>
          </h2>
        </div>
      </div>
    </div>
  );
};

export default BlogPostCard;
